module.exports = __webpack_public_path__ + "images/microsoft-icon-01d3f16b2bdab39a69d2e0f2019dd696.png";